import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Typography, Button, Paper, Container } from '@mui/material';
import {
    Home as HomeIcon,
    ArrowBack as ArrowBackIcon,
    Warning as WarningIcon,
} from '@mui/icons-material';

const NotFoundPage: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const isAdminPath = location.pathname.startsWith('/admin');

    return (
        <Container maxWidth="sm">
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                minHeight="80vh"
            >
                <Paper
                    elevation={3}
                    sx={{
                        p: 4,
                        textAlign: 'center',
                        borderRadius: 2,
                        width: '100%',
                    }}
                >
                    <Box
                        sx={{
                            bgcolor: 'warning.light',
                            borderRadius: '50%',
                            width: 80,
                            height: 80,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mx: 'auto',
                            mb: 3,
                        }}
                    >
                        <WarningIcon sx={{ fontSize: 48, color: 'warning.dark' }} />
                    </Box>

                    <Typography variant="h1" sx={{ fontSize: '5rem', fontWeight: 'bold', color: 'text.secondary' }}>
                        404
                    </Typography>

                    <Typography variant="h5" gutterBottom sx={{ mt: 1 }}>
                        Stránka nenalezena
                    </Typography>

                    <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                        Požadovaná stránka neexistuje nebo byla přesunuta.
                    </Typography>

                    <Box display="flex" gap={2} justifyContent="center" flexWrap="wrap">
                        <Button
                            variant="outlined"
                            startIcon={<ArrowBackIcon />}
                            onClick={() => navigate(-1)}
                        >
                            Zpět
                        </Button>
                        <Button
                            variant="contained"
                            startIcon={<HomeIcon />}
                            onClick={() => navigate(isAdminPath ? '/admin' : '/')}
                        >
                            {isAdminPath ? 'Admin Dashboard' : 'Hlavní stránka'}
                        </Button>
                    </Box>
                </Paper>
            </Box>
        </Container>
    );
};

export default NotFoundPage;
